import moment from 'moment';
import { mapState } from 'vuex';
import customColorMixin from '@/mixins/customColor';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreVirtualDevicePacketViewer',
  mixins: [customColorMixin],
  props: {
    height: {
      type: Number,
      default: 300,
      required: false
    },
    headline: {
      type: String,
      required: false,
      default: null
    },
    bridgeManifest: {
      type: Object,
      required: false,
      default: null
    },
    valuePath: {
      type: String,
      required: true
    },
    packetHistory: {
      type: Array,
      required: true
    },
    dataIsLoading: {
      type: Boolean,
      required: false
    },
    loadingError: {
      type: String,
      required: false,
      default: null
    },
    loadingDone: {
      type: Boolean,
      required: false
    },
    showLoadMore: {
      type: Boolean,
      required: false
    },
    isLiveViewer: {
      type: Boolean,
      required: true
    },
    noPacketLabel: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      scrolledDown: false,
      update: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language']),
    hasNoPackets() {
      return !this.dataIsLoading && this.packetHistory.length === 0 && this.loadingDone;
    },
    colNumber() {
      const baseCol = 3;
      const hasExternalId = get(this.packetHistory, '[0].externalId') !== undefined;
      const hasFrameCounter = get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.frameCounter');
      const hasPortManifest = get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.port');
      const hasPortPackets = get(this.packetHistory[0], `value.${hasPortManifest}`);
      const metaDataLength = (get(this.bridgeManifest, 'virtualDevice.metaData') || []).length;
      return baseCol + (hasExternalId ? 1 : 0) + (hasFrameCounter ? 1 : 0) + (hasPortManifest && hasPortPackets ? 1 : 0) + metaDataLength;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs['outer-card'].$el.addEventListener('scroll', this.debouncedScrollCalc);
    });
  },
  methods: {
    get,
    clickRowHandler(item) {
      this.$emit('click', item);
    },
    debouncedScrollCalc: debounce(function () {
      const el = this.$refs['top-element'];
      const holder = this.$refs['outer-container'];
      const {
        top,
        bottom,
        height
      } = el.getBoundingClientRect();
      const holderRect = holder.getBoundingClientRect();
      const isVisible = top <= holderRect.top ? holderRect.top - top <= height : bottom - holderRect.bottom <= height;
      this.scrolledDown = !isVisible;
    }, 250),
    localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(a).format('L LTS');
      }
      return '-';
    }
  }
};